import { buildModelManager } from "../builder.js";
const DefaultReconcileCursorSelection = {
  __typename: true,
  id: true,
  accountingConnectionId: true,
  createdAt: true,
  entityType: true,
  errorsCount: true,
  lastEntityId: true,
  lastEntityUpdatedAt: true,
  lastReconciledAt: true,
  processedCount: true,
  status: true,
  updatedAt: true
};
const modelApiIdentifier = "reconcileCursor";
const pluralModelApiIdentifier = "reconcileCursors";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultReconcileCursorSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultReconcileCursorSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultReconcileCursorSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultReconcileCursorSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultReconcileCursorSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultReconcileCursorSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultReconcileCursorSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "reconcileCursorGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ReconcileCursorManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultReconcileCursorSelection,
  operations
);
export {
  DefaultReconcileCursorSelection,
  ReconcileCursorManager
};
//# sourceMappingURL=ReconcileCursor.js.map
